<template>
  <v-flex xs12 class="my-2">
    <v-tabs
      class="r5"
      v-model="tab"
      color="grey6"
      :ripple="false"
      slider-color="primary"
      active-class="v-tabs__item--active primary cr-team-shadow white--text"
    >
      <v-tab href="#balance">
        <span class="hidden-sm-and-down">{{ $t("balance") }}</span>
        <span class="hidden-md-and-up">BLC</span>
      </v-tab>
      <v-tab href="#dailyProfit" v-if="customer.type == 'DailyProfit'">
        <span class="hidden-sm-and-down">{{ $t("daily_profits") }}</span>
        <span class="hidden-md-and-up">DPS</span>
      </v-tab>
      <template v-else>
        <v-tab href="#credits">
          <span class="hidden-sm-and-down">{{ $t("cash_receipts") }}</span>
          <span class="hidden-md-and-up">CRS</span>
        </v-tab>
        <v-tab href="#debits">
          <span class="hidden-sm-and-down">{{ $t("cash_payments") }}</span>
          <span class="hidden-md-and-up">DBS</span>
        </v-tab>
        <v-tab href="#exchanges">
          <span class="hidden-sm-and-down">{{ $t("exchange") }}</span>
          <span class="hidden-md-and-up">EXS</span>
        </v-tab>
      </template>
      <v-tab href="#transfers">
        <span class="hidden-sm-and-down">{{ $t("transfers") }}</span>
        <span class="hidden-md-and-up"> TRS </span>
      </v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab" touchless>
      <v-tab-item value="balance">
        <all-transactions
          @saved="saved"
          v-bind="{
            initList: false,
            accountView: true,
            account,
            end_date,
            customer,
            start_date,
            transactions,
          }"
        >
          <template slot="picker">
            <!-- <div class="di-flex align-start"> -->
            <v-date
              input_id="start_date_tr"
              :disabled="loading"
              :clearable="false"
              format="YYYY-MM-DD"
              v-model="start_date"
              singleLine
              :hideDetails="true"
              value-type="YYYY-MM-DD"
              @input="getTransactions"
              :placeholder="$t('from_date')"
              class="flex xs12 md2 mt-1 hide-details"
            />
            <v-date
              singleLine
              :hideDetails="true"
              :disabled="loading"
              :clearable="false"
              v-model="end_date"
              format="YYYY-MM-DD"
              input_id="end_date_tr"
              value-type="YYYY-MM-DD"
              @input="getTransactions"
              :placeholder="$t('to_date')"
              class="flex xs12 md2 mx-1 mt-1 hide-details"
            />
            <!-- </div> -->
          </template>
        </all-transactions>
      </v-tab-item>

      <v-tab-item value="credits">
        <credits
          @saved="saved"
          v-bind="{
            initList: false,
            accountView: true,
            credits,
            st_date: start_date,
            en_date: end_date,
          }"
        />
      </v-tab-item>

      <v-tab-item value="debits">
        <debits
          @saved="saved"
          v-bind="{
            initList: false,
            accountView: true,
            debits,
            st_date: start_date,
            en_date: end_date,
          }"
        />
      </v-tab-item>

      <v-tab-item value="exchanges">
        <exchanges
          @saved="saved"
          v-bind="{
            initList: false,
            accountView: true,
            exchanges,
            st_date: start_date,
            en_date: end_date,
          }"
        />
      </v-tab-item>

      <v-tab-item value="transfers">
        <transfers
          label="transaction_transfers"
          @saved="saved"
          v-bind="{
            initList: false,
            accountView: true,
            transfers,
            st_date: start_date,
            en_date: end_date,
          }"
        />
      </v-tab-item>
      <v-tab-item value="dailyProfit">
        <daily-profits
          @saved="saved"
          v-bind="{
            initList: false,
            accountView: true,
            dailyProfits,
            st_date: start_date,
            en_date: end_date,
          }"
        />
      </v-tab-item>
    </v-tabs-items>
  </v-flex>
</template>

<script>
import debits from "@/views/roznamcha/tabs/debits";
import credits from "@/views/roznamcha/tabs/credits";
import exchanges from "@/views/roznamcha/tabs/exchanges";
import transfers from "@/views/roznamcha/tabs/transfers";
import dailyProfits from "@/views/roznamcha/tabs/dailyProfits";
import allTransactions from "@/views/roznamcha/tabs/allTransactions";

let currentDate = new Date();
currentDate.setDate(currentDate.getDate() - 7);
export default {
  props: ["account", "customer"],
  components: {
    debits,
    credits,
    exchanges,
    transfers,
    dailyProfits,
    allTransactions,
  },
  data: () => ({
    transfer: {},
    dialog: false,
    loading: false,
    tab: "balance",
    transactions: [],
    end_date: new Date().toLocaleDateString("en-ca"),
    start_date: currentDate.toLocaleDateString("en-ca"),
  }),
  computed: {
    debits() {
      return this.transactions
        .filter(
          (x) => x.src_type == "debit" || x.src_type == "debit_commission"
        )
        .map((item) => item.item);
    },
    credits() {
      return this.transactions
        .filter(
          (x) => x.src_type == "credit" || x.src_type == "credit_commission"
        )
        .map((item) => item.item);
    },

    exchanges() {
      return this.transactions
        .filter(
          (x) => x.src_type == "exchange" || x.src_type == "exchange_profit"
        )
        .map((item) => item.item);
    },
    transfers() {
      return this.transactions
        .filter((x) => x.src_type == "transfer" || x.src_type == "commission")
        .map((item) => item.item);
    },
    dailyProfits() {
      return this.transactions
        .filter((x) => x.src_type == "DailyProfit")
        .map((item) => item.item);
    },
  },
  methods: {
    reset() {
      this.editIndex = -1;
      this.dialog = false;
      this.transfer = {
        id: null,
        done: 1,
        amount: null,
        description: "",
        type: this.type,
        currency_id: null,
        receiver_id: null,
        has_commission: false,
        commission_amount: null,
        sender_id: this.customer.id,
        commission_currency_id: null,
        date: new Date().toLocaleDateString("en-ca"),
      };
    },
    saved(transaction) {
      this.$emit("update");
      this.reset();
    },

    getTransactions(account) {
      this.loading = true;
      this.axios
        .get(
          `account-transactions/${this.account.id}?start_date=${this.start_date}&end_date=${this.end_date}`
        )
        .then((res) => {
          this.transactions = res.data.transactions;
          this.account.balance = res.data.balance;
          this.account.opening_balance = res.data.opening_balance;
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
          this.$router.push("/404");
        });
    },
  },

  watch: {
    account: {
      deep: true,
      handler() {
        this.getTransactions(this.account);
      },
    },
  },

  created() {
    this.reset();
    this.getTransactions();
  },
};
</script>